import React from 'react';
import PropTypes from 'prop-types';
import momentObj from 'moment';
import 'moment/locale/id';

const Label = ({
  className, variant, moment, momentFormat, icon, iconPosition, style, children, ...rest
}) => {
  const classNameArr = ['ajaib-label'];
  if (variant && availableVariants.includes(variant)) {
    if (variant === 'secondary hover-primary') {
      classNameArr.push('label-secondary');
      classNameArr.push('hover-primary');
    } else if (variant === 'secondary hover-danger') {
      classNameArr.push('label-secondary');
      classNameArr.push('hover-danger');
    } else {
      classNameArr.push(`label-${variant}`);
    }
  }

  if (style) {
    for (const forbid of forbiddenStyle) {
      if (style[forbid]) delete style[forbid];
    }
  }
  return (
    <div className={`${className} ${classNameArr.join(' ')}`} style={style} {...rest}>
      {
        moment ? (
          momentObj(children).locale('id').format(momentFormat)
        ) : (
          children
        )
      }
    </div>
  );
};

const availableVariants = [
  'primary', 'danger', 'secondary', 'outline-primary', 'outline-danger', 'outline-primary-rounded', 'outline-danger-rounded',
  'disabled', 'disabled-rounded', 'blue-light', 'blue-light-rounded',
  'primary-rounded', 'danger-rounded', 'secondary-rounded'
];
const forbiddenStyle = [
  'color', 'fontWeight', 'fontSize', 'background',
  'backgroundColor', 'border', 'borderRadius', 'display',
  'padding', 'paddingTop', 'paddingBottom', 'paddingLeft',
  'paddingRight', 'lineHeight'
];

Label.propTypes = {
  className: PropTypes.string,
  variant: PropTypes.string,
  moment: PropTypes.bool,
  momentFormat: PropTypes.string,
  style: PropTypes.object,
};

Label.defaultProps = {
  className: '',
  variant: 'primary',
  moment: false,
  momentFormat: 'D MMM YYYY',
  style: null,
};

export default Label;
